import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { UserCircle2 } from "lucide-react";

export default function Navbar() {
  const { user } = useAuth();
  return (
    <nav className="w-full px-6 md:px-12 py-6 flex items-center justify-between border-b border-cognac/15 bg-ivory/80 backdrop-blur-sm sticky top-0 z-30" data-testid="site-navbar">
      <Link to="/" className="group" data-testid="brand-link">
        <div className="flex flex-col leading-none">
          <span className="label-overline">Financial Advisor</span>
          <span className="font-serif text-2xl md:text-3xl text-oxblood tracking-tight mt-1">
            Aisha <span className="italic text-cognac">Bourdanne</span>
          </span>
        </div>
      </Link>
      <div className="hidden md:flex items-center gap-8">
        <a href="/#topics" className="text-sm text-oxblood/80 hover:text-oxblood link-underline" data-testid="nav-topics">Topics</a>
        <a href="/#how" className="text-sm text-oxblood/80 hover:text-oxblood link-underline" data-testid="nav-how">How it works</a>
        {user ? (
          <Link to="/me" className="inline-flex items-center gap-2 text-sm text-oxblood hover:text-cognac link-underline" data-testid="nav-profile">
            <UserCircle2 size={16} /> {user.full_name.split(" ")[0]}
          </Link>
        ) : (
          <Link to="/login" className="text-sm text-oxblood/80 hover:text-oxblood link-underline" data-testid="nav-login">Sign in</Link>
        )}
        <Link to="/book" className="btn-primary" data-testid="nav-book-button">Book — Free</Link>
      </div>
      <Link to="/book" className="md:hidden btn-primary text-[10px] px-5 py-3" data-testid="nav-book-mobile">Book</Link>
    </nav>
  );
}
